"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayAction = exports.HorizontalToolbar = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const layout_1 = require("./shared/layout");
exports.HorizontalToolbar = props => {
    const containerStyle = {
        alignItems: "center",
        justifyItems: "center",
        height: `${props.height}px`,
        padding: `0 1vw`
    };
    return react_1.default.createElement(layout_1.FlexRow, { style: containerStyle }, [...props.actions.map(a => react_1.default.createElement(exports.DisplayAction, { itemToRender: a }))]);
};
exports.DisplayAction = props => {
    const { itemToRender } = props;
    if (isActionItem(itemToRender)) {
        return react_1.default.createElement(layout_1.FlexRow, { style: { alignItems: "center", cursor: "pointer", margin: "0px 0.5vw" }, onClick: e => { itemToRender.action(); e.stopPropagation(); } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: itemToRender.icon }),
            react_1.default.createElement("div", { style: { margin: "0px 5px" } },
                " ",
                itemToRender.name,
                " "));
    }
    else {
        return itemToRender;
    }
};
function isActionItem(actionItem) {
    return actionItem.name && actionItem.icon && actionItem.action;
}
//# sourceMappingURL=action-toolbar.js.map